import React, { useState } from 'react';

interface Props {
  images: string[];
  mainWidth?: string;
  mainHeight?: string;
  thumbSize?: string;
}

const ProductImageGallery: React.FC<Props> = ({
  images,
  mainWidth = 'w-[375px]',
  mainHeight = 'h-[296px]',
  thumbSize = 'w-16 h-16',
}) => {
  const [selectedImage, setSelectedImage] = useState(images[0]);

  if (!images || images.length === 0) return null;

  return (
    <div className="flex flex-col">
      {/* Main Image */}
      <img
        src={selectedImage}
        alt={""}
        className={`${mainWidth} ${mainHeight} object-cover rounded-[32px]`}
      />

      {/* Thumbnails */}
      {images.length > 1 && (
        <div className="flex gap-2 mt-2">
          {images.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`${""} ${idx + 1}`}
              className={`${thumbSize} object-cover rounded cursor-pointer border-2 ${
                selectedImage === img ? 'border-primary' : 'border-gray-300'
              }`}
              onClick={() => setSelectedImage(img)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductImageGallery;
